import Link from "next/link";
import { ChevronRight, Home } from "lucide-react";

export interface BreadcrumbItem {
 label: string;
 href?: string;
}

interface BreadcrumbsProps {
 items: BreadcrumbItem[];
}

export function Breadcrumbs({ items }: BreadcrumbsProps) {
 return (
 <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm text-muted-foreground mb-6 flex-wrap">
 <Link href="/" className="hover:text-blue-600 transition-colors shrink-0">
 <Home className="w-3.5 h-3.5" />
 </Link>
 {items.map((item, i) => (
 <span key={i} className="flex items-center gap-1.5">
 <ChevronRight className="w-3.5 h-3.5 text-muted-foreground/60 shrink-0" />
 {item.href ? (
 <Link href={item.href} className="hover:text-blue-600 transition-colors">
 {item.label}
 </Link>
 ) : (
 <span className="text-foreground font-medium">{item.label}</span>
 )}
 </span>
 ))}
 </nav>
 );
}
